/**
 * @generated SignedSource<<77e198b32ca79ee50097fdd25107b871>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type FeatureToggleDataKind = "abandonedCartReminder" | "courseRecommendations" | "experimentalMode" | "inProductExpressCheckout" | "noConsentOrderAttribution" | "paymentProviderInvoiceNotice" | "profileEnrichmentSetName" | "scheduledGlobalDiscount" | "secciDownloadCheckout" | "signupMarketingOptIn" | "splitCourseCertification" | "storyblokCampaigns" | "timeBasedLicenses";
import { FragmentRefs } from "relay-runtime";
export type featureTogglesScreen_FeatureToggleFragment$data = {
  readonly __typename: "FeatureToggle";
  readonly data: {
    readonly isActive?: boolean;
    readonly kind: FeatureToggleDataKind;
    readonly name?: string;
  };
  readonly id: string;
  readonly " $fragmentType": "featureTogglesScreen_FeatureToggleFragment";
};
export type featureTogglesScreen_FeatureToggleFragment$key = {
  readonly " $data"?: featureTogglesScreen_FeatureToggleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"featureTogglesScreen_FeatureToggleFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "featureTogglesScreen_FeatureToggleFragment"
};

(node as any).hash = "0ddb4c2e6cf4092c1c902a62f178f2c7";

export default node;
